import { UrlObject } from 'url';

import { cartIdQuery } from '@water-web/view';

export const convertUrlToRoute = ({ pathname, query }: UrlObject): string =>
  pathname
    .replace(/\[(.+?)]/g, (_match, queryParam) => query?.[queryParam] ?? queryParam)
    .concat(query?.[cartIdQuery] ? `?${cartIdQuery}=${query[cartIdQuery]}` : '');
